const module = {
  getCoreInfo() {
    return {
      coreModelStatus: 2,
    };
  },
};

export default module;
